module.exports = __webpack_public_path__ + "static/media/add-icon.2ff32335.svg";